import { FC, SVGProps } from 'react';

const Contract: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 2.6003C19.5 2.27014 19.2313 2 18.9029 2H9.50824C9.349 2 9.19973 2.06003 9.0803 2.18009L5.17914 6.10205C5.05971 6.21211 5 6.37219 5 6.53227V21.3997C5 21.7299 5.2687 22 5.59712 22H18.8929C19.2213 22 19.49 21.7299 19.49 21.3997V13.3557C19.49 13.3157 19.49 13.2856 19.4801 13.2556L19.5 2.6003ZM18.3058 15.0265V20.7994H6.20419V7.13257H9.41867C9.74708 7.13257 10.0158 6.86243 10.0158 6.53227V3.2006H18.3058L18.2958 14.9065C18.2958 14.9465 18.2958 14.9865 18.3058 15.0265ZM8.61256 16.3672L15.8874 16.3472C16.2059 16.3472 16.4647 16.6073 16.4547 16.9475C16.4547 17.2776 16.2059 17.5478 15.8874 17.5478L8.61256 17.5678C8.30405 17.5678 8.0453 17.2976 8.0453 16.9675C8.0453 16.6373 8.2941 16.3672 8.61256 16.3672ZM8.63245 14.1661L15.8874 14.1461C16.1959 14.1461 16.4547 13.8759 16.4547 13.5458C16.4547 13.2156 16.1959 12.9455 15.8874 12.9455L8.63245 12.9655C8.32394 12.9655 8.06519 13.2356 8.06519 13.5658C8.06519 13.8959 8.31398 14.1661 8.63245 14.1661ZM8.63247 9.3637H15.8974C16.2059 9.3637 16.4647 9.63383 16.4647 9.964C16.4647 10.2942 16.2059 10.5643 15.8875 10.5643H8.63247C8.31401 10.5643 8.05526 10.2942 8.05526 9.964C8.05526 9.63383 8.31401 9.3637 8.63247 9.3637Z"
      fill="currentColor"
    />
  </svg>
);

export default Contract;
